/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { IGraph, LNode } from "../types";

export function decompose(g: IGraph): IGraph[] {
	const out = [];

	while (true) {
		const map = {};
		const n = g.getNodes();
		if (!n.length) return out;
		visitAll(n[0], map);
		const sub = g.split(a => !map[a.id]);

		out.push(g);
		if (sub) {
			g = sub;
		} else {
			return out;
		}
	}
}

function visitAll(n: LNode, visited) {
	visited[n.id] = 1;
	n.links.forEach(x => {
		if (!visited[x.id]) {
			visitAll(x, visited);
		}
	});
}
